// import cookie.js
import Cookies from 'js-cookie'

// dialog
const dialog = document.getElementById('dialog');
const closeDialogButton = document.getElementById('close-dialog');

// open dialog
function openDialog() {
    dialog.showModal();
    // add class no-scroll to html
    document.documentElement.classList.add('no-scroll');
}

// close dialog
function closeDialog() {

    dialog.close();

    // remove class no-scroll from html
    document.documentElement.classList.remove('no-scroll');

    // set cookie to prevent dialog from opening again
    Cookies.set(modal_cookie, { expires: 365, path: ''});
}

// if dialog exists
if(dialog) {
    
    // check if cookie is set 
    if(Cookies.get(modal_cookie)) {

        closeDialog();

    } else {

        document.addEventListener('DOMContentLoaded', openDialog);

    }

    // Close dialog on button click
    closeDialogButton.addEventListener('click', closeDialog);

    // close on escape button 
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
            closeDialog();
        }
    });

}
// remove cookie
// Cookies.remove(modal_cookie);